import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
// import { IAddNews } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const EditNewsModal: React.FC<any> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [option, setOption] = useState<string>("");
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		newsStatus,
		currentImgURL,
		setNewsStatus,
		newsIsHighlight,
		setNewsIsHighlight,
		setNews,
		currentNewsInfo,
	} = props;

	const handleRegister = (values: any) => {
		api
			.put(`/news/${currentNewsInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setNews && setNews(undefined);
					api.get("/news").then((res) => {
						setNews && setNews(res.data.data.news);
					});
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setNewsIsHighlight(false);
						setIsActive(false);
						setNewsStatus(false);
						setCurrentImgURL("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentNewsInfo?.title,
				description: currentNewsInfo?.description,
				visibility:
					currentNewsInfo?.visibility === "public" ? "public" : "private",
			});
			setOption(
				currentNewsInfo?.visibility === "public" ? "public" : "private"
			);
			setCurrentImgURL(currentNewsInfo?.image ? currentNewsInfo?.image : "");
			setNewsStatus(currentNewsInfo?.status === "publish" ? true : false);
			setNewsIsHighlight(currentNewsInfo?.is_highlight === true ? true : false);
			setIsActive(currentNewsInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar notícia</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar notícia"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									content: value,
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  }
							: {
									...values,
									content: value,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  };
						handleRegister(allValues);
						console.log(allValues);
						setCurrentImgURL("");
						// setNewsStatus(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setNewsIsHighlight(false);
				setIsActive(false);
				setNewsStatus(false);
				setCurrentImgURL("");
				form.resetFields();
			}}
			className="m-modal-news"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-news-modal">
					<div className="m-news-modal__login-info">
						<div className="m-news-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-news-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasEdited(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div
							className="m-news-modal__login-info__inputs"
							style={{ justifyContent: "space-evenly" }}
						>
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título da notícia" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessária",
									},
								]}
							>
								<Input placeholder="Descrição da notícia" />
							</Form.Item>

							<div
								style={{ display: "flex", width: "96%", alignItems: "center" }}
							>
								<Form.Item
									name="visibility"
									rules={[
										{
											required: true,
											message: "Visibilidade necessária",
										},
									]}
									style={{ margin: 0, width: "100%" }}
								>
									<Select
										placeholder="Visibilidade"
										className="m-news-modal__select"
										value={option}
										onChange={(e) => setOption(e)}
									>
										<Option value="public">Público</Option>
										<Option value="private">Privado</Option>
									</Select>
								</Form.Item>
								<div
									className="m-news-modal__status"
									style={{ margin: "0 10px 0 10px" }}
								>
									<p>Publicado</p>
									<Switch
										checked={newsStatus}
										onClick={(e) => setNewsStatus(e)}
									/>
								</div>
								<div
									className="m-news-modal__status"
									style={{ margin: "0 10px 0 0px" }}
								>
									<p>Destacar</p>
									<Switch
										checked={newsIsHighlight}
										onClick={(e) => setNewsIsHighlight(e)}
									/>
								</div>
								<div className="m-news-modal__status">
									<p>Ativo</p>
									<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
								</div>
							</div>
						</div>
					</div>

					<div className="m-news-modal__textarea" style={{ marginTop: "20px" }}>
						<ReactQuill theme="snow" value={value} onChange={setValue} />
					</div>
				</div>
			</Form>
		</Modal>
	);
};
